import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurkmenistan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1111)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C11.104 0 10.2313 0.0990469 9.39135 0.285234L8.86963 12L9.39135 23.7147C10.2313 23.9009 11.1041 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0V0Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.13053 3.91739C1.18597 6.05002 0.00012207 8.88642 0.00012207 12C0.00012207 15.1135 1.18601 17.9499 3.13058 20.0826L3.65229 12L3.13053 3.91739Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.5509 9.05151C18.1413 7.40592 17.478 5.61618 16.0546 4.72481C16.3106 4.75814 16.5669 4.81842 16.8199 4.90912C18.7185 5.59031 19.7054 7.68149 19.0242 9.58002C18.343 11.4787 16.2518 12.4655 14.3532 11.7843C14.1002 11.6936 13.864 11.5771 13.6453 11.4401C15.3107 11.657 16.9605 10.6971 17.5509 9.05151Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2764 4.27373L13.7633 4.93663L12.9745 4.65356L13.4463 5.34627L12.9333 6.00909L13.738 5.77443L14.2099 6.46706L14.2352 5.62931L15.0399 5.3946L14.251 5.11162L14.2764 4.27373Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6617 6.43369L15.1486 7.09654L14.3597 6.81347L14.8316 7.50619L14.3186 8.169L15.1232 7.93425L15.5952 8.62701L15.6206 7.78922L16.4252 7.55447L15.6363 7.27144L15.6617 6.43369Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.834 5.06038L11.3209 5.72319L10.5321 5.44021L11.004 6.13288L10.491 6.79574L11.2955 6.56103L11.7675 7.25371L11.7929 6.41596L12.5975 6.18125L11.8086 5.89818L11.834 5.06038Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7778 7.53455L11.2648 8.19741L10.4758 7.91437L10.9478 8.60709L10.4347 9.26991L11.2394 9.03525L11.7113 9.72787L11.7366 8.89012L12.5413 8.65542L11.7523 8.37234L11.7778 7.53455Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1321 8.37927L13.6191 9.04208L12.8302 8.75905L13.3022 9.45177L12.7891 10.1145L13.5938 9.87988L14.0657 10.5726L14.091 9.73476L14.8957 9.5001L14.1067 9.21707L14.1321 8.37927Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.13049 3.91739V20.0826C4.76549 21.8757 6.93722 23.1706 9.39136 23.7147V0.285233C6.93717 0.829264 4.76554 2.12419 3.13049 3.91739Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.51973 6.31805L4.47156 5.53721V4.43297L5.51973 3.65218H7.00215L8.05032 4.43297V5.53721L7.00215 6.31805H5.51973Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26096 3.65218H5.51973L4.47156 4.43297V4.97283H6.26096V3.65218Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26099 6.31805H7.00217L8.05035 5.5372V4.97391H6.26099V6.31805Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.51973 20.3477L4.47156 19.5669V18.4627L5.51973 17.6819H7.00215L8.05032 18.4627V19.5669L7.00215 20.3477H5.51973Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26096 17.6819H5.51973L4.47156 18.4627V19.0026H6.26096V17.6819Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26099 20.3477H7.00217L8.05035 19.5669V19.0036H6.26099V20.3477Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.51961 13.3329L4.47144 12.5521V11.4479L5.51961 10.667H7.00203L8.0502 11.4479V12.5521L7.00203 13.3329H5.51961Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.08694 15.0509H7.63038V14.5944H6.82811L6.26083 14.0271L5.6936 14.5944H4.89133V15.0509H4.43481V15.9639H4.89133V16.4204H5.69355L6.26088 16.9877L6.82811 16.4204H7.63038V15.9639H8.08694V15.0509Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.08694 8.03597H7.63038V7.57941H6.82811L6.26083 7.01213L5.6936 7.57941H4.89133V8.03597H4.43481V8.94901H4.89133V9.40552H5.69355L6.26088 9.9729L6.82811 9.40552H7.63038V8.94901H8.08694V8.03597Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.73914 11.4782H6.78262V12.5217H5.73914V11.4782Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26085 9.01402C6.54899 9.01402 6.78257 8.78044 6.78257 8.4923C6.78257 8.20416 6.54899 7.97058 6.26085 7.97058C5.97272 7.97058 5.73914 8.20416 5.73914 8.4923C5.73914 8.78044 5.97272 9.01402 6.26085 9.01402Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26085 16.0293C6.54899 16.0293 6.78257 15.7957 6.78257 15.5076C6.78257 15.2194 6.54899 14.9858 6.26085 14.9858C5.97272 14.9858 5.73914 15.2194 5.73914 15.5076C5.73914 15.7957 5.97272 16.0293 6.26085 16.0293Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1111",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTurkmenistan;
